// --- GETTERS ---
export const GET_LINKS_LIST = 'GET_LINKS_LIST';
export const GET_IS_LOADING = 'GET_IS_LOADING';
export const GET_ERROR = 'GET_ERROR';


// --- MUTATIONS ---
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_LINKS = 'SET_LINKS';
export const UPDATE_LINK_IN_LIST = 'UPDATE_LINK_IN_LIST';
export const CLEAR_STATE = 'CLEAR_STATE';


// --- ACTIONS ---
export const CREATE_LINK = 'CREATE_LINK';
export const FETCH_LINKS = 'FETCH_LINKS';
export const REVOKE_LINK = 'REVOKE_LINK';
export const UPDATE_LINK = 'UPDATE_LINK';
export const FETCH_LINK_BY_SCALE_ID = 'FETCH_LINK_BY_SCALE_ID';
export const FETCH_LINK_BY_GROUP_ID = 'FETCH_LINK_BY_GROUP_ID';
